import { useCallback } from 'react';
export function useScrollCallback(_a) {
    var headerRef = _a.headerRef;
    return useCallback(function (_a) {
        var scrollLeft = _a.scrollLeft;
        var _b;
        (_b = headerRef.current) === null || _b === void 0 ? void 0 : _b.style.setProperty('transform', "translateX(-" + Math.round(scrollLeft) + "px)");
    }, [headerRef]);
}
//# sourceMappingURL=useScrollCallback.js.map